"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseQuery_1 = require("./BaseQuery");

var utils_1 = require("../utils");

var Query_1 = require("./Query");

var ClientConfigurationQuery =
/** @class */
function (_super) {
  __extends(ClientConfigurationQuery, _super);

  function ClientConfigurationQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ClientConfigurationQuery.prototype.initialize = function (executionOptions) {
    this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
    this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
  };

  ClientConfigurationQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        code = _a.code,
        codeQuery = _a.codeQuery,
        key = _a.key,
        keyQuery = _a.keyQuery,
        _b = _a.options,
        options = _b === void 0 ? {} : _b;
    return __assign({
      code: code,
      codeQuery: codeQuery,
      key: key,
      keyQuery: keyQuery
    }, options.clientConfiguration || {});
  };

  ClientConfigurationQuery.prototype.getRawValue = function (executionOptions) {
    var _a = this.options,
        code = _a.code,
        key = _a.key;
    var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
    var _b = (context || {}).clientConfigurations,
        clientConfigurations = _b === void 0 ? {} : _b;
    var clientConfiguration = clientConfigurations[code];

    if (clientConfiguration) {
      var value = utils_1.get(clientConfiguration, key);
      return value;
    }

    return undefined;
  };

  return ClientConfigurationQuery;
}(BaseQuery_1.BaseQuery);

exports.ClientConfigurationQuery = ClientConfigurationQuery;